export default __webpack_public_path__ + "static/media/feedback-icon.7b047621.svg";